import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchProvince, fetchProvinceCreate, editProvince,
} from "Actions/Admin/Setup/ProvinceActions";



/**
 * The Province Edit Dialog
 */
class ProvinceEdit extends React.Component {
    // The Initial Data
    initialData = {
        provinceID : 0,
        countryID  : 0,
        name       : "",
        code       : "",
        status     : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, fetchProvince, fetchProvinceCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchProvince(elemID);
                loading = true;
            } else {
                fetchProvinceCreate();
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editProvince(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, countries, onClose } = this.props;
        const { data, loading, errors            } = this.state;

        return <EditDialog
            open={open}
            icon="province"
            title={!!elemID ? "PROVINCES_EDIT_TITLE" : "PROVINCES_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="select"
                name="countryID"
                label="PROVINCES_COUNTRY"
                value={data.countryID}
                error={errors.countryID}
                onChange={this.handleChange}
                options={countries}
                withNone
                isRequired
            />
            <InputField
                name="name"
                label="PROVINCES_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                name="code"
                label="PROVINCES_CODE"
                value={data.code}
                error={errors.code}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getFemSelect()}
                withNone
                isRequired
                shrinkLabel
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchProvince       : PropTypes.func.isRequired,
        fetchProvinceCreate : PropTypes.func.isRequired,
        editProvince        : PropTypes.func.isRequired,
        open                : PropTypes.bool.isRequired,
        onClose             : PropTypes.func.isRequired,
        onSubmit            : PropTypes.func.isRequired,
        edition             : PropTypes.number.isRequired,
        countries           : PropTypes.array.isRequired,
        elem                : PropTypes.object.isRequired,
        elemID              : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition   : state.province.edition,
            countries : state.province.countries,
            elem      : state.province.elem,
        };
    }
}

export default connect(ProvinceEdit.mapStateToProps, {
    fetchProvince, fetchProvinceCreate, editProvince,
})(ProvinceEdit);
